import { createRouter, createWebHistory } from 'vue-router';
import TOP from './views/TOP.vue';
import Company from './views/Company.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import Terms from './views/Terms.vue';
import Legal from './views/Legal.vue';
import SquatLockerPrivacyPolicy from './views/SquatLockerPrivacyPolicy.vue';
import SquatLockerTerms from './views/SquatLockerTerms.vue';
import NimeePrivacyPolicy from './views/NimeePrivacyPolicy.vue';
import NimeeTerms from './views/NimeeTerms.vue';
import Share from './views/Share.vue';
import ShareCallback from './views/ShareCallback.vue';

const routes = [
        {
                path: '/',
                name: 'top',
                component: TOP
        },
        {
                path: '/company',
                name: 'company',
                component: Company
        },
        {
                path: '/privacy-policy',
                name: 'privacy-policy',
                component: PrivacyPolicy
        },
        {
                path: '/terms',
                name: 'terms',
                component: Terms
        },
        {
                path: '/legal',
                name: 'legal',
                component: Legal
        },
        {
                path: '/squat-locker-privacy-policy',
                name: 'squat-locker-privacy-policy',
                component: SquatLockerPrivacyPolicy
        },
        {
                path: '/squat-locker-terms',
                name: 'squat-locker-terms',
                component: SquatLockerTerms
        },
        {
                path: '/nimee-privacy-policy',
                name: 'nimee-privacy-policy',
                component: NimeePrivacyPolicy
        },
        {
                path: '/nimee-terms',
                name: 'nimee-terms',
                component: NimeeTerms
        },
        {
                path: '/share',
                name: 'share',
                component: Share
        },
        {
                path: '/share/callback',
                name: 'share-callback',
                component: ShareCallback
        },
        {
                path: '/:pathMatch(.*)*', // キャッチオールルートを追加
                redirect: '/'
        }
];

const router = createRouter({
        history: createWebHistory(),
        routes,
        scrollBehavior() {
                // 常にページトップにスクロール
                return { top: 0 }
        }
});

export default router;
